import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Row, Col, Button, Form, Input, notification,
} from 'antd';
import './ForgotPassword.scss';
import Background from '../sharedComponents/Background/Background';
import logo from '../../assets/images/CooperLogo.png';
import {
  post, ResponseWrapper, RequestWrapper, isSuperAgentError,
} from '../../dataSource/requests';

interface ForgotPasswordForm {
  email: string;
}

const ForgotPassword = (): JSX.Element => {
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const [formInstance] = Form.useForm();

  const handleSubmit = async (values: ForgotPasswordForm): Promise<void> => {
    setLoading(true);

    let response: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;
    let genericError: Error | undefined;

    const requestReference: RequestWrapper = post({
      url: `/auth/forgotPassword/${values.email.toLowerCase()}`,

      frontConfigs: {
        navigateFunction: navigate,
      },
    });

    try {
      response = await requestReference;
    } catch (error: unknown) {
      console.log(error);
      if (isSuperAgentError(error)) {
        responseError = error.response;
      } else {
        genericError = error as Error;
      }
    }

    setLoading(false);

    switch (true) {
      case (response?.body?.code === 1007):
        // "Password reset mail sent successfully", 1007
        notification.success({
          message: 'Verifique seu email.',
          description: 'Enviamos instruções ao endereço de email informado.',
        });
        break;

      case (responseError?.body?.code === -4001):
        // "You must be authenticated to perform this operation", -4001
        break;

      case (responseError?.body?.code === -1007):
        // "You must be authenticated to perform this operation", -1007
        notification.error({
          message: 'Usuario não encontrado.',
          description: 'Verifique e tente novamente.',
        });
        break;

      case (genericError?.message?.includes('has been aborted')):
        // dont show anything when request is aborted
        break;

      default:
        notification.error({
          message: 'Usuario não encontrado.',
          description: 'Verifique e tente novamente.',
        });
        break;
    }
  };

  return (
    <div className="ForgotPassword">
      <Row>
        <Col xs={{ span: 0 }} md={{ span: 14 }} className="ForgotPassword__background">
          <Background />
        </Col>
        <Col xs={{ span: 24 }} md={{ span: 10 }} className="ForgotPassword__content">
          <div className="ForgotPassword__container">
            <img className="ForgotPassword__logo-image" src={logo} alt="" />

            <h3 className="ForgotPassword__title">Esqueceu a senha?</h3>

            <p className="ForgotPassword__texto">Insira seu email cadastrado e te enviaremos as instruções para a recuperação da senha.</p>

            <Form
              scrollToFirstError
              className="ForgotPassword__form"
              onFinish={handleSubmit}
              form={formInstance}
              noValidate
            >
              <Form.Item
                className="ForgotPassword__FormItemEmail"
                name="email"
                rules={[
                  { required: true, message: 'Por favor, insira seu email.' },
                  {
                    type: 'email',
                    message: 'Formato de email inválido.',
                  },
                  {
                    pattern: /^[a-z,A-z,0-9,@,.,_,-]+$/,
                    message: 'Não utilize caracteres especiais ou acentuados.',
                  },
                ]}
              >
                <Input
                  className="ForgotPassword__EmailInput"
                  type="email"
                  placeholder="Email"
                />
              </Form.Item>

              <Form.Item
                className="ForgotPassword__FormItemButton"
              >
                <Button
                  type="primary"
                  htmlType="submit"
                  className="ForgotPassword__FormButton"
                  loading={loading}
                >
                  CONFIRMAR
                </Button>
              </Form.Item>
              <Button
                className="ForgotPassword__voltar"
                type="link"
                onClick={
                  (): void => {
                    navigate('/');
                  }
                }
              >
                voltar para o login
              </Button>
            </Form>
          </div>
        </Col>
      </Row>
    </div>
  );
};

ForgotPassword.propTypes = {
};

ForgotPassword.defaultProps = {
};

export default ForgotPassword;
